<template>
  <svg width="947" height="1353" viewBox="0 0 947 1353" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.1" filter="url(#filter0_f_7284_4384)">
      <rect x="-212" y="414" width="745" height="745" rx="320" fill="#6171E4"/>
    </g>
    <defs>
      <filter id="filter0_f_7284_4384" x="-626" y="0" width="1573" height="1573" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
        <feGaussianBlur stdDeviation="207" result="effect1_foregroundBlur_7284_4384"/>
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>
